import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, TextField } from '@shopify/polaris'

const BalanceEditForm = ({ balance, editingBalance, onSave, onCancel, onBalanceChange }) => {
	const { t } = useTranslation()

	return (
		<div style={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-evenly'
		}}>
			<TextField
				type='number'
				value={balance}
				onChange={onBalanceChange}
			/>
			<div style={{
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end'
			}}>
				<Button
					variant='primary'
					loading={editingBalance}
					onClick={onSave}
				>
					{t("taxCorePages.common.save")}
				</Button>
				<Button
					disabled={editingBalance}
					onClick={onCancel}
				>
					{t("taxCorePages.common.cancel")}
				</Button>
			</div>
		</div>
	)
}

export default BalanceEditForm
